module.exports = __webpack_public_path__ + "media/cafe_genuss_webvideo_hoch_NEU_V1.c3f3932d.mp4";